import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    resumen: [],
    cuentas: [],
    cuentasDisplay: [],
    comprobantes: [],
    cuenta: null,
    rubro: null,
    subrubro: null,
    proveedor: null,

    fechaDesde: moment(new Date((new Date().getFullYear()), 
        (new Date().getMonth()), 1)).format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,
    
    'INICIALIZAR_RESUMEN' (state) {
        state.resumen = [];
        state.cuentas = [];
        state.cuentasDisplay = [];

        state.comprobantes = [];
        state.cuenta = null;
        state.rubro = null;
        state.subrubro = null;
        state.proveedor = null;
    },

    'SET_RESUMEN' (state, resumen) {
        state.resumen = resumen;
        state.comprobantes = [];
        state.cuenta = null;
        state.rubro = null;
        state.subrubro = null;
        state.proveedor = null;

        /* Cuenta + Rubro + Subrubro + Proveedor + Monto */
        resumen.forEach(item => {
            let proveedor = state.cuentas
                .find(cuenta => cuenta.cuentaId == item.cuentaId
                        & cuenta.rubroId == item.rubroId
                        & cuenta.subrubroId == item.subrubroId
                        & cuenta.proveedorId == item.proveedorId);
            if (!proveedor) {
                if (item.proveedorId != 0) {
                    state.cuentas.push({
                        cuentaId: item.cuentaId,
                        rubroId: item.rubroId,
                        subrubroId: item.subrubroId,
                        proveedorId: item.proveedorId,
                        nombre: item.proveedor.trim(),
                        monto: 0,
                        cuenta: item.cuenta.trim(),
                        rubro: item.rubro.trim(),
                        subrubro: item.subrubro.trim(),
                        sorting: `${item.cuenta.trim()}-${item.rubro.trim()}-${item.subrubro.trim()}-${item.proveedor.trim()}`,
                        visible: false,
                        expanded: false,
                        _rowVariant: 'proveedor'
                    });
                }
            }
        });

        /* Calculamos el monto de cada proveedor */
        state.cuentas.forEach(cuenta => {
            cuenta.monto = state.resumen
                .filter(item => item.cuentaId == cuenta.cuentaId
                    & item.rubroId == cuenta.rubroId
                    & item.subrubroId == cuenta.subrubroId
                    & item.proveedorId == cuenta.proveedorId)
                .reduce((total, item) => total + item.monto, 0);
        });

        /* Agregamos un renglon por cada subrubro */
        state.cuentas.forEach(item => {
            let subrubro = state.cuentas
                .find(cuenta => cuenta.cuentaId == item.cuentaId
                        & cuenta.rubroId == item.rubroId
                        & cuenta.subrubroId == item.subrubroId
                        & cuenta.proveedorId == 0);
            if (!subrubro) {
                if (item.subrubroId != 0) {
                    state.cuentas.push({
                        cuentaId: item.cuentaId,
                        rubroId: item.rubroId,
                        subrubroId: item.subrubroId,
                        proveedorId: 0,
                        nombre: item.subrubro.trim(),
                        monto: 0,
                        sorting: `${item.cuenta.trim()}-${item.rubro.trim()}-${item.subrubro.trim()}`,
                        visible: false,
                        expanded: false,
                        _rowVariant: 'subrubro'
                    });
                }
            }
        });

        /* Calculamos el monto de cada subrubro */
        state.cuentas
            .filter(subrubro => subrubro.proveedorId == 0)
            .forEach(subrubro => {
                subrubro.monto = state.resumen
                    .filter(item => item.cuentaId == subrubro.cuentaId
                        & item.rubroId == subrubro.rubroId
                        & item.subrubroId == subrubro.subrubroId)
                    .reduce((total, item) => total + item.monto, 0);
            });

        /* Agregamos un renglon por cada rubro */
        state.cuentas.forEach(item => {
            let rubro = state.cuentas
                .find(cuenta => cuenta.cuentaId == item.cuentaId
                        & cuenta.rubroId == item.rubroId
                        & cuenta.subrubroId == 0
                        & cuenta.proveedorId == 0);
            if (!rubro) {
                if (item.rubroId != 0) {
                    state.cuentas.push({
                        cuentaId: item.cuentaId,
                        rubroId: item.rubroId,
                        subrubroId: 0,
                        proveedorId: 0,
                        nombre: item.rubro.trim(),
                        monto: 0,
                        sorting: `${item.cuenta.trim()}-${item.rubro.trim()}`,
                        visible: false,
                        expanded: false,
                        _rowVariant: 'rubro'
                    });
                }
            }
        });

        /* Calculamos el monto de cada rubro */
        state.cuentas
            .filter(rubro => rubro.subrubroId == 0 & rubro.proveedorId == 0)
            .forEach(rubro => {
                rubro.monto = state.resumen
                    .filter(item => item.cuentaId == rubro.cuentaId
                        & item.rubroId == rubro.rubroId)
                    .reduce((total, item) => total + item.monto, 0);
            });
        
        /* Agregamos un renglon por cada cuenta */
        state.cuentas.forEach(item => {
            let cuenta = state.cuentas
                .find(cuenta => cuenta.cuentaId == item.cuentaId
                        & cuenta.rubroId == 0
                        & cuenta.subrubroId == 0
                        & cuenta.proveedorId == 0);
            if (!cuenta) {
                if (item.cuentaId != 0) {
                    state.cuentas.push({
                        cuentaId: item.cuentaId,
                        rubroId: 0,
                        subrubroId: 0,
                        proveedorId: 0,
                        nombre: item.cuenta.trim(),
                        monto: 0,
                        sorting: `${item.cuenta.trim()}`,
                        visible: true,
                        expanded: false,
                        _rowVariant: 'cuenta'
                    });
                }
            }
        });

        /* Calculamos el monto de cada cuenta */
        state.cuentas
            .filter(cuenta => cuenta.rubroId == 0 
                & cuenta.subrubroId == 0
                & cuenta.proveedorId == 0)
            .forEach(cuenta => {
                cuenta.monto = state.resumen
                    .filter(item => item.cuentaId == cuenta.cuentaId)
                    .reduce((total, item) => total + item.monto, 0);
            });

        state.cuentas.sort(function(a, b){
            let x = a.sorting.toLowerCase();
            let y = b.sorting.toLowerCase();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
            
        /* Totales */
        let montoTotal = state.cuentas
            .reduce((total, cuenta) => {
                if (cuenta.proveedorId != 0) {
                    return total + cuenta.monto;
                }
                return total;
            }, 0);

        state.cuentas.push({
            cuentaId: 0,
            rubroId: 0,
            subrubroId: 0,
            proveedorId: 0,
            nombre: 'TOTALES',
            monto: montoTotal,
            visible: true,
            expanded: false,
            _rowVariant: 'totales'
        });

        state.cuentasDisplay = state.cuentas.filter(cuenta => cuenta.visible == true);
    },
    'EXPANDIR_CONTRAER_CUENTA' (state, cuentaId) {
        let cuenta = state.cuentas
            .find(cuenta => cuenta.cuentaId == cuentaId
                & cuenta.rubroId == 0
                & cuenta.subrubroId == 0);
        if (cuenta) {
            if (cuenta.expanded) {
                cuenta.expanded = false;
                /* Contraemos rubros y subrubros */
                let items = state.cuentas
                    .filter(item => item.cuentaId == cuentaId
                        & (item.rubroId != 0 || item.subrubroId != 0 || item.proveedorId != 0));
                if (items) {
                    items.forEach(item => {
                        item.visible = false;
                        if (item.rubroId != 0 || item.subrubroId != 0) {
                            item.expanded = false;
                        }
                    });
                }
            } else {
                cuenta.expanded = true;
                /* Expandimos rubros */
                let rubros = state.cuentas
                    .filter(rubro => rubro.cuentaId == cuentaId
                        & rubro.rubroId != 0
                        & rubro.subrubroId == 0
                        & rubro.proveedorId == 0);
                
                let getProveedores = true;
                if (rubros) {
                    if (rubros.length != 0) {
                        rubros.forEach(rubro => {
                            rubro.visible = true;
                        });
                        getProveedores = false;
                    }
                }
                if (getProveedores) {
                    /* No tiene rubros ni subrubros, expandimos proveedores */
                    let proveedores = state.cuentas
                        .filter(proveedor => proveedor.cuentaId == cuentaId
                            & proveedor.rubroId == 0
                            & proveedor.subrubroId == 0
                            & proveedor.proveedorId != 0);
                    if (proveedores) {
                        proveedores.forEach(proveedor => {
                            proveedor.visible = true;
                        });
                    }
                }            
            }
        }

        state.cuentasDisplay = state.cuentas.filter(cuenta => cuenta.visible == true);
    },
    'EXPANDIR_CONTRAER_RUBRO' (state, rubroId) {
        let rubro = state.cuentas
            .find(rubro => rubro.rubroId == rubroId
                & rubro.subrubroId == 0);
        if (rubro) {
            if (rubro.expanded) {
                rubro.expanded = false;
                /* Contraemos rubros y subrubros */
                let items = state.cuentas
                    .filter(item => item.rubroId == rubroId
                        & (item.subrubroId != 0 || item.proveedorId != 0));
                if (items) {
                    items.forEach(item => {
                        item.visible = false;
                        if (item.subrubroId != 0) {
                            item.expanded = false;
                        }
                    });
                }
            } else {
                rubro.expanded = true;
                /* Expandimos subrubros */
                let subrubros = state.cuentas
                    .filter(subrubro => subrubro.rubroId == rubroId
                        & subrubro.subrubroId != 0
                        & subrubro.proveedorId == 0);
                
                let getProveedores = true;
                if (subrubros) {
                    if (subrubros.length != 0) {
                        subrubros.forEach(subrubro => {
                            subrubro.visible = true;
                        });
                        getProveedores = false;
                    }
                } 
                if (getProveedores) {
                    /* No tiene subrubros, expandimos proveedores */
                    let proveedores = state.cuentas
                        .filter(proveedor => proveedor.rubroId == rubroId
                            & proveedor.subrubroId == 0
                            & proveedor.proveedorId != 0);
                    if (proveedores) {
                        proveedores.forEach(proveedor => {
                            proveedor.visible = true;
                        });
                    }
                }
            }
        }

        state.cuentasDisplay = state.cuentas.filter(cuenta => cuenta.visible == true);
    },    
    'EXPANDIR_CONTRAER_SUBRUBRO' (state, subrubroId) {
        let subrubro = state.cuentas
            .find(subrubro => subrubro.subrubroId == subrubroId
                & subrubro.proveedorId == 0);
        if (subrubro) {
            if (subrubro.expanded) {
                subrubro.expanded = false;
                /* Contraemos proveedores */
                let items = state.cuentas
                    .filter(item => item.subrubroId == subrubroId
                        & item.proveedorId != 0);
                if (items) {
                    items.forEach(item => {
                        item.visible = false;
                    });
                }
            } else {
                subrubro.expanded = true;
                /* Expandimos proveedores */
                let proveedores = state.cuentas
                    .filter(proveedor => proveedor.subrubroId == subrubroId
                        & proveedor.proveedorId != 0);
                if (proveedores) {
                    proveedores.forEach(proveedor => {
                        proveedor.visible = true;
                    });
                }
            }
        }

        state.cuentasDisplay = state.cuentas.filter(cuenta => cuenta.visible == true);
    },
    'SET_COMPROBANTES' (state, params) {
        setComprobantes(state, params);
    },   
};

function setComprobantes(state, params) {
    let cuentaId = 0;
    let rubroId = 0;
    let subrubroId = 0;
    let proveedorId = 0;

    if (params) {
        cuentaId = params.cuentaId;
        rubroId = params.rubroId;
        subrubroId = params.subrubroId;
        proveedorId = params.proveedorId;
    }

    state.comprobantes = state.resumen
        .filter(comprobante => comprobante.cuentaId == cuentaId
            & comprobante.rubroId == rubroId
            & comprobante.subrubroId == subrubroId
            & comprobante.proveedorId == proveedorId  )
        .map(comprobante =>  ({...comprobante}));
    
    state.cuenta = null;
    state.rubro = null;
    state.subrubro = null;
    state.proveedor = null;

    if (state.comprobantes.length != 0) {
        let comprobante = state.comprobantes[0];

        state.cuenta = comprobante.cuenta.trim();
        state.rubro = comprobante.rubro.trim();
        state.subrubro = comprobante.subrubro.trim();
        state.proveedor = comprobante.proveedor.trim();
    }
}

const actions = {
    inicializar: ({commit}) => {
        commit ('INICIALIZAR_RESUMEN');
    },
    getResumenGastos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR_RESUMEN');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            apiAxios.get('compras/rpt/resumen-gastos' + queryString)
                .then(res => {
                    commit ('SET_RESUMEN', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    expandirContraerCuenta: ({commit}, cuentaId) => {
        commit ('EXPANDIR_CONTRAER_CUENTA', cuentaId);
    },
    expandirContraerRubro: ({commit}, rubroId) => {
        commit ('EXPANDIR_CONTRAER_RUBRO', rubroId);
    },
    expandirContraerSubrubro: ({commit}, subrubroId) => {
        commit ('EXPANDIR_CONTRAER_SUBRUBRO', subrubroId);
    },
    setComprobantes({commit}, params) {
        commit ('SET_COMPROBANTES', params);
    }
};

const getters = {
    getField,

    rptCuentas(state) {
        return {
            fechaDesde: state.fechaDesde,
            fechaHasta: state.fechaHasta,
            cuentas: state.cuentas
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}